export default __webpack_public_path__ + "static/media/no-4-answer.ad3a7267.png";